"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = {
    ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
    AUTHORIZATION_REQUIRED: 'AUTHORIZATION_REQUIRED',
    CHAT_ENDED: 'CHAT_ENDED',
    CUSTOMER_DISABLED: 'CUSTOMER_DISABLED',
    FILE_NOT_FOUND: 'FILE_NOT_FOUND',
    FILE_TYPE_NOT_ALLOWED: 'FILE_TYPE_NOT_ALLOWED',
    FILE_USED: 'FILE_USED',
    FILE_UPLOAD_FAILED: 'FILE_UPLOAD_FAILED',
    FORBIDDEN: 'FORBIDDEN',
    IMAGE_NOT_FOUND: 'IMAGE_NOT_FOUND',
    INVALID_ACTION_TYPE: 'INVALID_ACTION_TYPE',
    INVALID_CUSTOMER_ROLE: 'INVALID_CUSTOMER_ROLE',
    INVALID_IMAGE: 'INVALID_IMAGE',
    INVALID_ROLE: 'INVALID_ROLE',
    INVALID_STATUS_RESPONSE: 'INVALID_STATUS_RESPONSE',
    ITEM_NOT_FOUND: 'ITEM_NOT_FOUND',
    MEMBER_NOT_FOUND: 'MEMBER_NOT_FOUND',
    MEMO_ALREADY_ACTIONED: 'MEMO_ALREADY_ACTIONED',
    MEMO_CATEGORY_NOT_FOUND: 'MEMO_CATEGORY_NOT_FOUND',
    MEMO_HIDDEN: 'MEMO_HIDDEN',
    ORGANISATION_DISABLED: 'ORGANISATION_DISABLED',
    PERMISSION_EXISTS: 'PERMISSION_EXISTS',
    PERMISSION_REQUESTED: 'PERMISSION_REQUESTED',
    REQUEST_NOT_FOUND: 'REQUEST_NOT_FOUND',
    REQUEST_TOO_LARGE: 'REQUEST_TOO_LARGE',
    RESPONSE_ALREADY_GIVEN: 'RESPONSE_ALREADY_GIVEN',
    SHARE_HIDDEN_MEMO: 'SHARE_HIDDEN_MEMO',
    VERIFICATION_REQUEST_FAILED: 'VERIFICATION_REQUEST_FAILED',
    VERIFICATION_RATE_LIMIT: 'VERIFICATION_RATE_LIMIT',
    VERIFICATION_CODE_INVALID: 'VERIFICATION_CODE_INVALID',
    PHONE_NUMBER_IN_USE: 'PHONE_NUMBER_IN_USE',
    EMAIL_IN_USE: 'EMAIL_IN_USE',
    CANNOT_SET_PHONE_NUMBER: 'CANNOT_SET_PHONE_NUMBER',
    CANNOT_SET_EMAIL: 'CANNOT_SET_EMAIL',
    CUSTOMER_PUBLIC_SHARING_DISABLED: 'CUSTOMER_PUBLIC_SHARING_DISABLED',
    ORG_PUBLIC_SHARING_DISABLED: 'ORG_PUBLIC_SHARING_DISABLED',
    PUBLIC_SHARE_FAILED: 'PUBLIC_SHARE_FAILED',
    PUBLIC_SHARE_HIDDEN_MEMO: 'PUBLIC_SHARE_HIDDEN_MEMO',
};
